// ANT Modules
import { Upload, Image } from "antd";

// components
import EmptyComponent from "components/atoms/EmptyComponent/EmptyComponent";

// Hooks
import { useFileUpload } from "components/atoms/FileUpload/useFileUpload";

// Constants & Utils
import getIcon from "utils/getIcon";
import { FILE_UPLOAD_CONSTANT as Constants } from "constants/global";

const { Dragger } = Upload;

export type FileUploadProps = {
	imageURL?: string;
	handleUpload?: (url: string) => void;
};

const FileUpload = ({ imageURL, handleUpload }: FileUploadProps) => {
	const acceptFileTypes = Constants.IMAGE_FILETYPE;
	const { fileList, beforeUpload, handleChange } = useFileUpload({ handleUpload, acceptFileTypes });

	const uploadHintContent = (
		<div>
			<p className="ant-upload-hint">
				{Constants.UPLOAD_TEXT}
				<br />
				<u>{Constants.BROWSE}</u>
			</p>
		</div>
	);

	return (
		<Dragger
			accept={Constants.IMAGE_FILETYPE}
			listType="text"
			showUploadList={{
				showRemoveIcon: true,
				removeIcon: (
					<div
						onClick={() => {
							handleUpload?.("");
						}}
					>
						{getIcon({ icon: "closeIcon" })}
					</div>
				)
			}}
			beforeUpload={beforeUpload}
			onChange={handleChange}
			fileList={fileList}
			maxCount={1}
			iconRender={EmptyComponent}
		>
			{imageURL ? <Image src={imageURL} alt="receipt_img_base64" preview={false} className="flex justify-center items-center h-[33rem]" /> : uploadHintContent}
		</Dragger>
	);
};

export default FileUpload;
